import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title, history } from "utils";
import { userActions } from "actions";
import { connect } from "react-redux";

import { Input, Button } from "antd";
import { Logo, Header } from "components";

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = { email: "", pwd: "" };
    this.handleChange = this.handleChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  handleChange(key, value) {
    this.setState({ [key]: value });
  }

  handleLogin(e) {
    e.preventDefault();

    const { email, pwd } = this.state;
    this.props.loginUser(email, pwd);
  }

  render() {
    return (
      <Fragment>
        <Helmet>
          {title("Connexion")}
          <body data-login="true" />
        </Helmet>

        <div className="login-page page-content">
          <Logo />

          <div className="main-content">
            <Header title="Connexion" />

            <form>
              <p>
                <label>Courriel :</label>
                <Input
                  onChange={(e) => this.handleChange("email", e.target.value)}
                  value={this.state.email}
                  onPressEnter={this.handleLogin}
                />
              </p>

              <p>
                <label>Mot de passe :</label>
                <Input.Password
                  onChange={(e) => this.handleChange("pwd", e.target.value)}
                  value={this.state.pwd}
                  onPressEnter={this.handleLogin}
                />
              </p>

              {this.props.error && (
                <b className="error">
                  {this.props.disabledError
                    ? "Ce compte est présentement désactivé"
                    : "Courriel ou mot de passe invalide"}
                </b>
              )}

              <div className="buttons">
                <Button type="primary" icon="login" onClick={this.handleLogin}>
                  Se connecter
                </Button>
              </div>

              {process.env.NODE_ENV === "development" && (
                <div className="buttons quick-login-trigger">
                  <Button icon="thunderbolt" onClick={() => history.push("/quick-login")}>
                    Connexion rapide (dev)
                  </Button>
                </div>
              )}
            </form>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    error: state.user.loginError,
    disabledError: state.user.disabledError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginUser: (email, password) => dispatch(userActions.login(email, password)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
